/**
 * Produktdaten für Cafe Konditorei Rieppel
 * Sortiment mit allen Kategorien, Produkten, Zutaten und Allergenen
 */

export const sortimentData = {
  mehlInfo: {
    name: "STEINMETZ PREMIUM MEHL",
    benefits: [
      "nachweisbar weniger Schadstoffe",
      "weniger Bakterien",
      "weniger Pilze"
    ],
    verfahren: "Beim Steinmetz-Verfahren wird nur die äußere Hülle entfernt, die schwer verdaulich ist und Bitterstoffe enthält.",
    ernaehrungsvorteile: [
      "leichter verdaulich",
      "Vitamine bleiben erhalten",
      "Mineralstoffe bleiben erhalten"
    ]
  },
  salzInfo: {
    type: "Natursalz",
    eigenschaften: [
      "naturbelassen",
      "frei von chemischen Zusätzen"
    ]
  },
  categories: [
    {
      id: "traditionelle",
      title: "Die Traditionellen",
      description: "Unsere klassischen Brote nach bewährten Rezepten",
      icon: "🍞",
      products: [
        {
          name: "Mischbrot",
          alias: "Hausbrot",
          description: "Traditionelles, saftiges Mischbrot.",
          available_sizes: ["1 kg Laib", "0.5 kg Laib"],
          image: "/images/products/mischbrot.webp",
          ingredients: [
            "Roggenmehl", "Weizenmehl", "Wasser", "Roggennatursauerteig",
            "Säuerungsmittel: Milchsäure", "Säuerungsmittel: Essigsäure",
            "Natursalz", "Hefe"
          ],
          allergens: ["Roggen", "Weizen"]
        },
        {
          name: "Roggenmischbrot",
          description: "Besteht vorwiegend aus Roggen und etwas geröstetem Roggen, was dem Brot eine sehr schmackhafte Art verleiht.",
          image: "/images/products/roggenmischbrot.webp",
          ingredients: [
            "Roggenmehl", "Weizenmehl", "Wasser", "Roggennatursauerteig",
            "Säuerungsmittel: Milchsäure", "Säuerungsmittel: Essigsäure",
            "Natursalz", "Hefe", "Roggenmalzmehl"
          ],
          allergens: ["Roggen", "Weizen"]
        },
        {
          name: "Tirolerbrot",
          description: "Dieses rustikale Roggenmischbrot ist durch seine knusprige Kruste gekennzeichnet.",
          image: "/images/products/tirolerbrot.webp",
          ingredients: [
            "Roggenmehl", "Weizenmehl", "Wasser", "Roggennatursauerteig",
            "Roggenmalzmehl", "Säuerungsmittel: Milchsäure", "Hefe",
            "Brotgewürz", "Natursalz"
          ],
          allergens: ["Roggen", "Weizen"]
        },
        {
          name: "Waldviertlerbrot",
          description: "Das sehr knusprig, aufgesprungene Brot nach Waldviertler Tradition passt hervorragend zu kalten Aufschnitten und Aufstrichen.",
          image: "/images/products/waldviertlerbrot.webp",
          ingredients: [
            "Roggenmehl", "Weizenmehl", "Wasser", "Roggennatursauerteig",
            "Säuerungsmittel: Milchsäure", "Natursalz", "Hefe"
          ],
          allergens: ["Roggen", "Weizen"]
        },
        {
          name: "Meterbrot",
          description: "Das Meterbrot, das nach Gewicht verkauft wird, zeichnet sich durch lange Haltbarkeit aus und schmeckt bei richtiger Lagerung auch nach Tagen noch frisch.",
          image: "/images/products/meterbrot.webp",
          ingredients: [
            "Roggenmehl", "Weizenmehl", "Wasser", "Roggennatursauerteig",
            "Säuerungsmittel: Milchsäure", "Natursalz", "Hefe"
          ],
          allergens: ["Roggen", "Weizen"]
        }
      ]
    },
    {
      id: "koernige",
      title: "Die Körnigen",
      description: "Vollwertige Brote mit Körnern, Nüssen und Saaten",
      icon: "🌾",
      products: [
        {
          name: "Kärntner Gewürzbauernbrot",
          description: "Das sehr knusprig, aufgesprungene Brot wird mit einer Vielzahl an Gewürzen verfeinert und passt somit hervorragend zu kalten Aufschnitten und Aufstrichen.",
          image: "/images/products/kaerntner-gewuerzbauernbrot.webp",
          ingredients: [
            "Steinmetz Roggenmehl", "Steinmetz Weizenmehl", "Wasser", "Roggennatursauerteig",
            "Fenchel", "Anis", "Kümmel", "Säuerungsmittel: Milchsäure", "Natursalz", "Hefe"
          ],
          allergens: ["Roggen", "Weizen"]
        },
        {
          name: "Karottennussbrot",
          description: "Besonders saftig und schmackhaft wird dieses Brot erst durch die Kombination von frischen Karotten mit Walnüssen.",
          image: "/images/products/karottennussbrot.webp",
          ingredients: [
            "Weizenmehl", "Roggenvollkornsauerteig", "Haferflocken", "Karotten", "Walnüsse",
            "Sonnenblumenkerne", "Leinsamen", "Meersalz", "Distelöl", "Malzextrakt", "Hefe"
          ],
          allergens: ["Roggen", "Weizen", "Gerste", "Soja", "Nüsse"]
        },
        {
          name: "Nussbrot",
          description: "Durch die aromatischen Walnüsse passt dieses Brot hervorragend zu Käse aller Art und einem Glas Rotwein.",
          image: "/images/products/nussbrot.webp",
          ingredients: [
            "Roggenmehl", "Weizenmehl", "Wasser", "Roggennatursauerteig", "Walnüsse",
            "Säuerungsmittel: Milchsäure", "Natursalz", "Hefe"
          ],
          allergens: ["Roggen", "Weizen", "Nüsse"]
        },
        {
          name: "Sonnenblumenbrot",
          description: "Das saftige Roggenmischbrot passt durch die Sonnenblumenkerne besonders gut zu Butter und Käse.",
          image: "/images/products/sonnenblumenbrot.webp",
          ingredients: [
            "Roggenmehl", "Weizenmehl", "Hafermehl", "Natursalz", "Natursauerteig",
            "Sonnenblumenkerne", "Traubenzucker", "Malzextrakt", "Topfen", "Weizenkleber", "Hefe"
          ],
          allergens: ["Roggen", "Weizen", "Milch"]
        },
        {
          name: "Fitberrybrot",
          description: "Gekennzeichnet ist dieses Brot durch die Zugabe von rotem Traubenkonzentrat, das reichlich sekundäre Pflanzeninhaltsstoffe besitzt, welche eine hohe antioxidative Zellschutz-Aktivität haben.",
          image: "/images/products/fitberrybrot.webp",
          ingredients: [
            "Weizenmehl", "Sonnenblumenkerne", "Weizenmalzschrot", "Gerstensauermalzschrot",
            "Malzextrakt", "Traubenkonzentrat", "Wasser", "Hefe"
          ],
          allergens: ["Weizen"]
        },
        {
          name: "Dinkelvollkornbrot",
          description: "Unser fein vermahlenes Dinkelvollkornbrot schmeckt besonders locker und leicht.",
          image: "/images/products/dinkelvollkornbrot.webp",
          ingredients: [
            "Dinkelvollkornmehl", "Dinkelflocken", "Roggenmehl", "Sonnenblumenkerne",
            "Wasser", "Dinkelvollkornsauerteig", "Hefe", "Natursalz"
          ],
          allergens: ["Dinkel", "Roggen"]
        },
        {
          name: "Dinkel-Emmer-Urkornbrot",
          description: "Der heutige Emmer besitzt weitgehend noch seine ursprüngliche Form und die Inhaltsstoffe überzeugen durch ein Potential an guten Eigenschaften.",
          image: "/images/products/dinkel-emmer-urkornbrot.webp",
          ingredients: [
            "Dinkelmehl", "Wasser", "Emmerkern", "Roggensauerteig (Roggenmehl, Wasser, Säuerungskulturen)",
            "Weizenmalz", "Weizeneiweiß", "Kartoffelflocken", "Roggenmehl", "Kürbiskerne", "Natursalz",
            "Dinkelvollkornsauerteig (Dinkelvollkornmehl, Wasser, Säuerungskulturen)", "Hefe"
          ],
          allergens: ["Dinkel", "Roggen", "Emmer", "Weizen"]
        },
        {
          name: "Roggen-Dinkelbrot ohne Hefe",
          description: "Das ideale Brot für Ernährungsbewusste besteht aus fein vermahlenem Dinkelmehl und Dinkelvollkornschrot, der trotz seines hohen Ballaststoffgehalts sehr bekömmlich und gut verdaulich ist.",
          image: "/images/products/roggen-dinkelbrot-ohne-hefe.webp",
          ingredients: [
            "Roggenmehl", "Dinkelmehl", "Wasser", "Natursauerteig", "Dinkelroggenmalzmehl",
            "Dinkelvollkornschrot", "Dinkelvollkornmehl", "Backpulver", "Salz", "Süßmolkenpulver",
            "Gerstemalzextrakt", "Traubenkonzentrat"
          ],
          allergens: ["Roggen", "Dinkel", "Gerste", "Milch"]
        },
        {
          name: "100% Roggenbrot (hefefrei)",
          description: "Ein Spezialbrot für noch mehr Abwechslung. Für alle Brotliebhaber, die auf Hefe verzichten möchten und reine Roggenbrote bevorzugen.",
          image: "/images/products/100prozent-roggenbrot-hefefrei.webp",
          ingredients: [
            "Steinmetz Roggenmehl", "Wasser", "Roggennatursauerteig", "Roggenmalz", "Natursalz"
          ],
          allergens: ["Roggen"]
        },
        {
          name: "Zwiebelbrot",
          description: "Durch die gerösteten Zwiebeln erhält das Brot einen aromatisch, pikanten Geschmack.",
          image: "/images/products/zwiebelbrot.webp",
          ingredients: [
            "Roggenmehl", "Weizenmehl", "Wasser", "Roggennatursauerteig", "Röstzwiebeln",
            "Käse", "Säuerungsmittel: Milchsäure", "Natursalz", "Hefe"
          ],
          allergens: ["Roggen", "Weizen", "Milch"]
        },
        {
          name: "Vintschgerl",
          description: "Das aus dem Vinschgau in Südtirol stammende Roggenlaibchen hat eine besonders schmackhafte rustikale Oberfläche.",
          image: "/images/products/vintschgerl.webp",
          ingredients: [
            "Roggenmehl", "Weizenmehl", "Wasser", "Roggennatursauerteig",
            "Säuerungsmittel: Milchsäure", "Roggenmalzmehl", "Natursalz", "Hefe"
          ],
          allergens: ["Roggen", "Weizen"]
        }
      ]
    },
    {
      id: "traditionelles-gebaeck",
      title: "Traditionelles Gebäck",
      description: "Handgeformtes Gebäck nach österreichischer Tradition",
      icon: "🥨",
      products: [
        {
          name: "Semmel",
          description: "Die Kaisersemmel ist nach wie vor das Lieblingsgebäck der Österreicher und wird bei uns von Hand geformt.",
          image: "/images/products/semmel.webp",
          ingredients: [
            "Weizenmehl", "Wasser", "Weizennatursauerteig", "jodiertes Salz",
            "pflanzliches Fett", "Hefe", "Weizenmalzmehl", "Gerstemalz"
          ],
          allergens: ["Weizen", "Gerste"]
        },
        {
          name: "Salzstangerl",
          description: "Das knusprig, resche Weizenkleingebäck ist ein Gaumengenuss mit österreichischer Tradition.",
          image: "/images/products/salzstangerl.webp",
          ingredients: [
            "Weizenmehl", "Wasser", "jodiertes Salz", "Backmittel", "pflanzliches Fett",
            "Weizenmalzmehl", "Gerstemalz", "Öl", "Hefe"
          ],
          topping: ["Salz", "Kümmel"],
          allergens: ["Weizen", "Gerste"]
        },
        {
          name: "Wachauer-Laibchen",
          description: "Das typische Gebäck beim Heurigen passt ideal zu verschiedenen Aufstrichen z.B. Liptauer.",
          image: "/images/products/wachauer-laibchen.webp",
          ingredients: [
            "Weizenmehl", "jodiertes Salz", "Backmittel", "Roggenmehl",
            "Kümmel", "Hefe", "Wasser"
          ],
          allergens: ["Weizen", "Sesam"]
        },
        {
          name: "Grahamweckerl",
          description: "Das goldbraune Weizenkleingebäck wird aus Weizenvollkornschrot hergestellt und unterstützt somit die Verdauung.",
          ingredients: [
            "Weizenmehl", "Grahamschrot", "Natursalz", "Backmittel",
            "Zucker", "Hefe", "Fett", "Wasser"
          ],
          allergens: ["Weizen"]
        },
        {
          name: "Mohn- und Sesamstriezerl",
          description: "Der beliebte Klassiker im Brotkörberl wird von uns handgeflochten und erhält durch den Sesam und Mohn seinen besonderen Geschmack.",
          image: "/images/products/mohn-und-sesamstriezerl.webp",
          ingredients: [
            "Weizenmehl", "Wasser", "Weizennatursauerteig", "pflanzliches Fett",
            "Backmittel", "Natursalz", "Hefe"
          ],
          topping: ["Mohn", "Sesam", "oder Käse"],
          allergens: ["Weizen"]
        },
        {
          name: "Laugenstangerl",
          description: "Die bayrische Spezialität findet auch bei uns immer mehr Anhänger und ist eine willkommene Abwechslung im Brotkörberl.",
          image: "/images/products/laugenstangerl.webp",
          ingredients: [
            "Weizenmehl", "Roggennatursauerteig", "Weizensauerteig", "Natursalz",
            "Wasser", "Kümmel", "Hefe", "Malzbackmittel", "pflanzliches Fett", "Natronlauge"
          ],
          allergens: ["Weizen", "Roggen"]
        },
        {
          name: "Toskanaweckerl",
          description: "Dieses italienische Gebäck wird bei uns ganz natürlich mit Natursauerteig hergestellt.",
          image: "/images/products/toskanaweckerl.webp",
          ingredients: [
            "Weizenmehl", "Weizensauerteig", "Wasser", "Natursalz",
            "Backmittel", "pflanzliches Fett", "Öl", "Hefe"
          ],
          topping: ["Salz", "Kümmel"],
          allergens: ["Weizen"]
        },
        {
          name: "Kornspitz",
          description: "Das Lieblingsgebäck der Österreicher passt zu jeder Mahlzeit!",
          image: "/images/products/kornspitz.webp",
          ingredients: [
            "Weizenschrot", "Roggenschrot", "Weizenmehl", "Leinsamen", "Malzflocken",
            "Sojaschrot", "Wasser", "Hefe", "Natursalz", "Backmittel"
          ],
          topping: ["Sesam"],
          allergens: ["Weizen", "Roggen", "Soja"]
        },
        {
          name: "Bierspitz",
          description: "Als hervorragende Alternative zum Salzstangerl ist der resche Bierspitz eine würzige Abwechslung im Brotkörberl.",
          image: "/images/products/bierspitz.webp",
          ingredients: [
            "Steinmetz Weizenmehl", "Roggenmalzflocken", "Wasser", "Natursalz", "Glukose",
            "Roggenmalz", "Gerstemalz", "Zwiebel", "Karotten", "Sellerie", "Kümmel",
            "Petersilie", "Liebstöckl", "pflanzliches Fett", "Zucker", "Hefeextrakt", "Milcheiweiß"
          ],
          allergens: ["Weizen", "Roggen", "Gerste", "Milch", "Sellerie"]
        }
      ]
    },
    {
      id: "koernige-weckerl",
      title: "Körnige Weckerl",
      description: "Vollwertiges Gebäck mit Körnern und Saaten",
      icon: "🌻",
      products: [
        {
          name: "Kürbiskernweckerl",
          description: "Ein hoher Anteil an steirischen Kürbiskernen geben diesem Spezialgebäck eine besondere Geschmacksnote.",
          image: "/images/products/kuerbiskernweckerl.webp",
          ingredients: [
            "Roggenmehl", "Weizenmehl", "Hafermehl", "Natursalz", "Natursauerteig",
            "Kürbiskerne", "Traubenzucker", "Malzextrakt", "Weizenkleber", "Hefe"
          ],
          allergens: ["Roggen", "Weizen", "Milch"]
        },
        {
          name: "Dinkel-Urspitz",
          description: "Mit seinen ursprünglichen Zutaten ist der Urspitz ein wertvoller Bestandteil einer ausgewogenen Ernährung.",
          image: "/images/products/dinkel-urspitz.webp",
          ingredients: [
            "Dinkelmehl", "Wasser", "Vollkorn-Urgetreide (Bauländer Spelz, Dinkel, Einkorn, Fisser Imperial Gerste, Waldstaudenroggenschrot, Khorasan, Emmer)",
            "geröstetes Roggenquellmehl", "Hefe", "Natursalz", "Braune Leinsaat",
            "Hartweizengrieß", "Weizenkeimmehl", "Gewürze", "Rapsöl"
          ],
          allergens: ["Gluten"]
        },
        {
          name: "Dinkelkornspitz",
          description: "Der besondere Kornspitz für den gesundheitsbewussten Genießer aus fein vermahlenem Dinkelvollkornmehl.",
          image: "/images/products/dinkelkornspitz.webp",
          ingredients: [
            "Dinkelvollkornmehl", "Dinkelmehl", "Meersalz", "Honig",
            "Sesam", "Traubenzucker", "Hefe"
          ],
          allergens: ["Weizen", "Sesam"]
        },
        {
          name: "Karottennussecke",
          description: "Die frischen Karottenstücke und Walnüsse passen hervorragend zueinander und machen dieses Gebäck unverwechselbar.",
          image: "/images/products/karottennussecke.webp",
          ingredients: [
            "Weizenmehl", "Roggenvollkornsauerteig", "Haferflocken", "Karotten", "Walnüsse",
            "Leinsamen", "Sonnenblumenkerne", "Meersalz", "Distelöl", "Malzextrakt", "Hefe"
          ],
          allergens: ["Roggen", "Weizen", "Gerste", "Soja", "Nüsse"]
        },
        {
          name: "Vollkornlaibchen",
          description: "Das ideale Gebäck für eine gesunde Jause enthält viele gesundheitsfördernde Ballaststoffe und schmeckt noch dazu gut.",
          image: "/images/products/vollkornlaibchen.webp",
          ingredients: [
            "Roggenschrot", "Weizenschrot", "Haferschrot", "Buchweizenschrot", "Gerstenschrot",
            "Hirseschrot", "Weizenvollmehl", "Sonnenblumenkerne", "Wasser", "Reis",
            "Leinsaat", "Malzmehl", "Natursalz", "Hefe"
          ],
          allergens: ["Weizen", "Roggen", "Gerste"]
        },
        {
          name: "Vollkornmüsliriegel",
          description: "Der gesunde Snack für Zwischendurch aus Vollkornmehl, vielen Nüssen und mit Sesam bestreut.",
          image: "/images/products/vollkornmuesliriegel.webp",
          ingredients: [
            "PurPur-Weizenvollkornmehl", "Wasser", "Roggenvollkornmehl", "Sauerteig", "Sojaschrot",
            "Kürbiskerne", "Walnüsse", "Zucker", "Natursalz", "Hefe", "Butter", "Rosinen",
            "gehobelte Mandeln", "Sesam", "Haferflocken", "Zimt"
          ],
          allergens: ["Weizen", "Roggen", "Nüsse"]
        },
        {
          name: "Roggen-Purriegel",
          description: "Kräftiges Roggengebäck mit natürlichem Sauerteig und aromatischen Brotgewürzen.",
          image: "/images/products/roggen-purriegel.webp",
          ingredients: [
            "Roggenmehl", "Weizenkleber", "Vollkornroggensauerteig", "Roggenmalzschrot",
            "Roggenkeimkleie", "Gerstemalz", "Natursalz", "Brotgewürze"
          ],
          allergens: ["Weizen", "Roggen"]
        }
      ]
    },
    {
      id: "mediterranes-gebaeck",
      title: "Mediterranes Gebäck",
      description: "Südländische Spezialitäten mit Käse, Oliven und Tomaten",
      icon: "🫒",
      products: [
        {
          name: "Tomatenkäseriegel",
          description: "Besonders aromatisch und schmackhaft schmeckt dieses mit Käse überbackene Weißgebäck erst durch die Zugabe von getrockneten Tomaten.",
          image: "/images/products/tomatenkaeseriegel.webp",
          ingredients: [
            "Weizenmehl", "Salz", "Weizennatursauerteig", "getrocknete Tomaten",
            "Käse", "Backmittel", "Natursalz", "Hefe", "Fett", "Wasser"
          ],
          allergens: ["Weizen", "Milch"]
        },
        {
          name: "Olivenkäseecke",
          description: "Dieses mediterrane Gebäck findet auch bei uns immer mehr Liebhaber besonders wenn man eine Vorliebe für Oliven hat.",
          image: "/images/products/olivenkaeseecke.webp",
          ingredients: [
            "Weizenmehl", "Natursalz", "Weizennatursauerteig", "Oliven",
            "Käse", "Backmittel", "Hefe", "Fett", "Wasser"
          ],
          allergens: ["Weizen", "Milch"]
        }
      ]
    },
    {
      id: "pikante-snacks",
      title: "Pikante Snacks",
      description: "Herzhafte Snacks für Zwischendurch",
      icon: "🥐",
      products: [
        {
          name: "Schinkenkipferl",
          description: "Die pikanten und aus lockerem Teig hergestellten Schinkenkipferl werden täglich frisch von uns gebacken.",
          image: "/images/products/schinkenkipferl.webp",
          ingredients: [
            "Weizenmehl", "Wasser", "Weizennatursauerteig", "pflanzliches Fett", "Schinken",
            "Käse", "Natursalz", "Hefe", "Weizenmalzmehl", "Gerstemalz"
          ],
          allergens: ["Weizen", "Gerste", "Milch"]
        },
        {
          name: "Käsestangerl",
          description: "Besonders würzig und geschmackvoll ist unser mit viel Käse überbackenes Stangerl.",
          image: "/images/products/kaesestangerl.webp",
          ingredients: [
            "Weizenmehl", "Milch", "Käse", "Butter", "Margarine",
            "Eier", "Natursalz", "Wasser", "Hefe", "Malzbackmittel"
          ],
          allergens: ["Weizen", "Milch", "Ei"]
        },
        {
          name: "Pizzaschnitte / Gemüseecke",
          description: "Der schnelle Snack für Zwischendurch wird von uns frisch gebacken. Erhältlich mit Schinken, Salami oder Gemüse nach Saison.",
          ingredients: [
            "Weizenmehl", "Wasser", "Käse", "passierte Tomaten",
            "Oregano", "Natursalz", "Hefe"
          ],
          allergens: ["Weizen", "Milch"]
        }
      ]
    },
    {
      id: "feines-plundergebaeck",
      title: "Feines Plundergebäck",
      description: "Handgeformtes Buttergebäck aus der Konditorei",
      icon: "🥮",
      products: [
        {
          name: "Butterkipferl",
          description: "Die Kipferl werden von uns täglich händisch geformt und mehrmals täglich frisch gebacken.",
          ingredients: [
            "Weizenmehl", "Milch", "Zucker", "Butter", "Margarine", "Eier",
            "Natursalz", "Wasser", "Hefe", "Malzbackmittel", "Vanille", "Zitrone"
          ],
          allergens: ["Weizen", "Milch", "Ei"]
        },
        {
          name: "Vollkornbutterkipferl",
          description: "Durch den Vollkornplunderteig wird das Kipferl besonders knusprig.",
          image: "/images/products/vollkornbutterkipferl.webp",
          ingredients: [
            "Weizenvollkornmehl", "Milch", "Zucker", "Butter", "Margarine", "Eier",
            "Natursalz", "Wasser", "Hefe", "Malzbackmittel", "Vanille", "Zitrone"
          ],
          allergens: ["Weizen", "Milch", "Ei"]
        },
        {
          name: "Briochekipferl oder -striezerl",
          description: "Frische Eier machten dieses feine Milchgebäck schon zu Kaisers Zeiten zu einem beliebten Frühstücksgebäck. Mit Hagelzucker oder Mandeln.",
          image: "/images/products/briochekipferl-oder-striezerl.webp",
          ingredients: [
            "Weizenmehl", "Milch", "Butter", "Zucker", "Hefe", "Vanille", "Rum"
          ],
          allergens: ["Weizen", "Milch", "Ei", "Mandel"]
        },
        {
          name: "Mürbes Kipferl",
          description: "Das klassische Wiener Frühstücksgebäck wird mit Butter und Marmelade bestrichen zu einem genussvollen Start in den Tag.",
          image: "/images/products/muerbes-kipferl.webp",
          ingredients: [
            "Weizenmehl", "Wasser", "Zucker", "Butter", "Milch", "Hefe", "Natursalz", "Dotter"
          ],
          allergens: ["Weizen", "Milch", "Ei"]
        },
        {
          name: "Mürbe Schnecke",
          description: "Das klassische Wiener Frühstücksgebäck in Schneckenform, mürbe gebacken und besonders zart.",
          ingredients: [
            "Weizenmehl", "Wasser", "Zucker", "Butter", "Milch", "Hefe", "Natursalz", "Dotter"
          ],
          allergens: ["Weizen", "Milch", "Ei"]
        },
        {
          name: "Topfengolatsche",
          description: "Der Plunderteig reift in unserer Backstube über 12 Stunden und wird anschließend von Hand geformt.",
          ingredients: [
            "Weizenmehl", "Milch", "Zucker", "Butter", "Margarine", "Eier",
            "Natursalz", "Wasser", "Hefe", "Malzbackmittel", "Vanille", "Zitrone", "Topfenfüllung"
          ],
          allergens: ["Weizen", "Milch", "Ei"]
        },
        {
          name: "Topfenstangerl",
          description: "Die feine Topfenfülle mit den saftigen Pfirsichstücken machen das süße Stangerl zu einer fruchtigen Abwechslung.",
          image: "/images/products/topfenstangerl.webp",
          ingredients: [
            "Weizenmehl", "Milch", "Butter", "Zucker", "Eier", "Natursalz", "Wasser",
            "Hefe", "Malzbackmittel", "Vanille", "Zitrone", "Topfenfüllung", "Pfirsiche", "Mandeln"
          ],
          allergens: ["Weizen", "Milch", "Ei", "Mandel"]
        }
      ]
    },
    {
      id: "frische-krapfen",
      title: "Frische Krapfen",
      description: "Täglich frisch gebacken in transfettfreiem Fett",
      icon: "🍩",
      products: [
        {
          name: "Marillenkrapfen",
          description: "Unsere frischen Krapfen schmecken, aus transfettfreiem Fett gebacken, noch besser. Gefüllt mit Marillenmarmelade.",
          image: "/images/products/marillenkrapfen.webp",
          ingredients: [
            "Weizenmehl", "Zucker", "Trockenmilch", "Wasser", "Natursalz",
            "Eier", "Fett", "Butter", "Vanille", "Zitrone", "Backmittel", "Hefe"
          ],
          allergens: ["Weizen", "Milch", "Ei"]
        },
        {
          name: "Vanille-, Nougat- und Powidlkrapfen",
          description: "Für den speziellen Genuss gibt es unsere Krapfen mit besonders leckeren Füllungen: Vanillecreme mit Kokos, Nougatcreme mit Haselnüssen, oder Powidl mit Mohn.",
          image: "/images/products/vanille-nougat-und-powidlkrapfen.webp",
          ingredients: [
            "Weizenmehl", "Zucker", "Trockenmilch", "Wasser", "Natursalz", "Eier",
            "Fett", "Butter", "Vanille", "Zitrone", "Backmittel", "Hefe", "Obers",
            "Nougat", "Kokos", "Haselnüsse", "Powidlmarmelade", "Mohn", "Rum"
          ],
          allergens: ["Weizen", "Milch", "Ei", "Nüsse"]
        },
        {
          name: "Donut",
          description: "Nicht nur die junge Generation findet Geschmack an den aus Krapfenteig hergestellten Donuts. Im transfettfreiem Fett gebacken, mit Schokoladenüberzug.",
          image: "/images/products/donut.webp",
          ingredients: [
            "Weizenmehl", "Milch", "Zucker", "Butter", "Eier", "Wasser", "Hefe", "Natursalz"
          ],
          allergens: ["Weizen", "Milch", "Ei"]
        }
      ]
    },
    {
      id: "hausgemachte-mehlspeisen",
      title: "Hausgemachte Mehlspeisen",
      description: "Traditionelle österreichische Süßspeisen aus der Backstube",
      icon: "🥧",
      products: [
        {
          name: "Dinkelbuchtel",
          description: "Das gesundheitsfördernde Dinkelmehl macht unsere flaumige Buchtel nicht nur zu einer Wohltat für den Gaumen, sondern auch für den Körper. Gefüllt mit Marillenmarmelade.",
          image: "/images/products/dinkelbuchtel.webp",
          ingredients: [
            "Dinkelmehl", "Eier", "Hefe", "pflanzliches Fett",
            "Topfen", "Natursalz", "Weizenkleber"
          ],
          allergens: ["Roggen", "Weizen", "Milch"]
        },
        {
          name: "Butterstriezel",
          description: "Unser feiner Striezel wird aus bester Butter hergestellt und schmeckt ganz ohne Zusatzstoffe besonders natürlich und gut.",
          image: "/images/products/butterstriezel.webp",
          ingredients: [
            "Weizenmehl", "Milch", "Eier", "Butter", "Rosinen",
            "Zucker", "Hefe", "Vanille", "Rum", "Kartoffelflocken", "Mandeln"
          ],
          allergens: ["Weizen", "Milch", "Ei", "Mandeln"]
        },
        {
          name: "Apfelstrudel",
          description: "Frische Äpfel und Brösel aus eigener Herstellung lassen unseren Apfelstrudel frisch und saftig schmecken.",
          image: "/images/products/apfelstrudel.webp",
          ingredients: [
            "Äpfel", "Zucker", "süße Brösel", "Butter", "Weizenmehl",
            "Öl", "Rosinen", "Zimt", "Natursalz"
          ],
          allergens: ["Weizen", "Milch"]
        },
        {
          name: "Obstplunder",
          description: "Mit frischem Obst nach Saison belegt und Vanillecreme gefüllt, schmeckt unser Obstplunder besonders saftig.",
          image: "/images/products/obstplunder.webp",
          ingredients: [
            "Weizenmehl", "Wasser", "Fett", "Zucker", "Eier", "Topfenfülle",
            "Vanillecreme", "Trockenmilch", "Zitrone", "Natursalz", "Ziehfett"
          ],
          allergens: ["Weizen", "Ei", "Milch"]
        },
        {
          name: "Kokosschnecke",
          description: "Wer Kokos und Vanillecreme mag, wird von dieser schmackhaften Kombination begeistert sein.",
          image: "/images/products/kokosschnecke.webp",
          ingredients: [
            "Weizenmehl", "Milch", "Zucker", "Butter", "Margarine", "Ei",
            "Natursalz", "Wasser", "Vanillecreme", "Kokosflocken", "Zitrone", "Hefe"
          ],
          allergens: ["Weizen", "Milch", "Ei"]
        },
        {
          name: "Zimtschnecke",
          description: "Der Klassiker aus unserer Backstube wird bei uns ohne Zuckerglasur zubereitet.",
          image: "/images/products/zimtschnecke.webp",
          ingredients: [
            "Weizenmehl", "Milch", "Zucker", "Butter", "Margarine", "Ei", "Natursalz",
            "Wasser", "Hefe", "Malzbackmittel", "Vanille", "Zitrone", "Nüsse", "Brösel", "Zimt"
          ],
          allergens: ["Weizen", "Milch", "Ei", "Nüsse"]
        }
      ]
    },
    {
      id: "feine-kipferl",
      title: "Feine Kipferl",
      description: "Gefüllte Kipferl und Beugel aus Plunderteig",
      icon: "🥐",
      products: [
        {
          name: "Nougatkipferl",
          description: "Feines Kipferl mit Nougatfüllung.",
          image: "/images/products/nougatkipferl.webp",
          ingredients: [
            "Weizenmehl", "Wasser", "Fett", "Zucker", "Eier", "Nougat", "Schokolade",
            "Trockenmilch", "Vanille", "Zitrone", "Natursalz", "Backmittel", "Hefe", "Ziehfett"
          ],
          allergens: ["Weizen", "Ei", "Milch"]
        },
        {
          name: "Zaunerkipferl",
          description: "Kipferl mit Nussbestreuung.",
          image: "/images/products/zaunerkipferl.webp",
          ingredients: [
            "Weizenmehl", "Wasser", "Fett", "Zucker", "Nüsse", "Eier",
            "Trockenmilch", "Vanille", "Zitrone", "Natursalz", "Hefe", "Backmittel", "Ziehfett"
          ],
          allergens: ["Weizen", "Ei", "Milch", "Nüsse"]
        },
        {
          name: "Nuss- und Kürbiskernbeugel",
          description: "Beugel mit Nuss- oder Kürbiskernfüllung.",
          image: "/images/products/nuss-und-kuerbiskernbeugel.webp",
          ingredients: [
            "Weizenmehl", "Wasser", "Fett", "Zucker", "Nüsse", "Kürbiskerne", "Eier",
            "Powidl", "Rosinen", "Zimt", "Rum", "Hefe", "Trockenmilch", "Vanille",
            "Zitrone", "Natursalz", "Backmittel"
          ],
          allergens: ["Weizen", "Ei", "Milch", "Nüsse"]
        },
        {
          name: "Topfenstrudel",
          description: "Strudel mit frischem Topfen.",
          image: "/images/products/topfenstrudel.webp",
          ingredients: [
            "Topfen", "Zucker", "Eier", "Margarine", "Rosinen",
            "Weizenmehl", "Öl", "Vanille", "Zitrone", "Natursalz"
          ],
          allergens: ["Weizen", "Milch"]
        },
        {
          name: "Kardinalschnitte",
          description: "Schnitte mit Kaffee-, Erdbeer- oder klassischer Variante.",
          image: "/images/products/kardinalschnitte.webp",
          ingredients: [
            "Eier", "Zucker", "Weizenmehl", "Vanille", "Zitrone",
            "Natursalz", "Stärkemehl", "Marmelade", "Obers"
          ],
          allergens: ["Weizen", "Ei", "Milch"]
        },
        {
          name: "Nougattorte",
          description: "Torte für Schokoladenliebhaber.",
          image: "/images/products/nougattorte.webp",
          ingredients: [
            "Eier", "Zucker", "Weizenmehl", "Nougat", "Schokolade",
            "Kakao", "Vanille", "Zitrone", "Natursalz", "Stärkemehl", "Obers"
          ],
          allergens: ["Weizen", "Ei", "Milch", "Nüsse"]
        },
        {
          name: "Linzer- und Kakaokipferl",
          description: "Wiener Spezialität, ideal zum Nachmittagskaffee.",
          image: "/images/products/linzer-und-kakaokipferl.webp",
          ingredients: [
            "Margarine", "Weizenmehl", "Zucker", "Eier", "Vanille",
            "Zitrone", "Natursalz", "Kakao", "Marmelade", "Schokolade"
          ],
          allergens: ["Weizen", "Ei", "Milch"]
        },
        {
          name: "Linzer Herzen und Dinkel-Linzer Herzen",
          description: "Feines Linzergebäck für besondere Anlässe oder den eigenen Genuss.",
          image: "/images/products/linzer-herzen-und-dinkel-linzer-herzen.webp",
          ingredients: [
            "Margarine", "Zucker", "Weizenmehl oder Dinkelmehl",
            "Vanille", "Zitrone", "Salz", "Ribiselmarmelade"
          ],
          allergens: ["Weizen", "Milch"]
        },
        {
          name: "Punschkrapfen",
          description: "Mit Nüssen, Schokolade und Rum verfeinert, besonders saftig durch den Überzug.",
          image: "/images/products/punschkrapfen.webp",
          ingredients: [
            "Margarine", "Zucker", "Weizenmehl", "Eier", "Schokolade",
            "Rum", "Nüsse", "Vanille", "Zitrone", "Natursalz", "Ribiselmarmelade"
          ],
          allergens: ["Weizen", "Milch", "Ei", "Nüsse"]
        },
        {
          name: "Rehrücken",
          description: "Schokoladengebäck für echte Schokoladenliebhaber.",
          image: "/images/products/rehruecken.webp",
          ingredients: [
            "Weizenmehl", "Margarine", "Zucker", "Eier", "Schokolade",
            "Kakao", "Mandeln", "Vanille", "Zitrone", "Natursalz", "Marillenmarmelade"
          ],
          allergens: ["Weizen", "Milch", "Ei", "Nüsse"]
        },
        {
          name: "Dinkel-Nuss-Strudel",
          description: "Händisch verarbeiteter Strudel aus Dinkelmehl mit Nussfüllung.",
          image: "/images/products/dinkel-nuss-strudel.webp",
          ingredients: [
            "Dinkelmehl", "Wasser", "Walnüsse", "Margarine", "Zucker",
            "Eier", "Rum", "Natursalz", "Hefe", "Zimt", "Mandeln"
          ],
          allergens: ["Dinkel", "Milch", "Ei", "Nüsse"]
        },
        {
          name: "Dinkel-Mohn-Strudel",
          description: "Saftiger Dinkelstrudel mit Mohnfüllung.",
          image: "/images/products/dinkel-mohn-strudel.webp",
          ingredients: [
            "Dinkelmehl", "Wasser", "Mohn", "Margarine", "Zucker",
            "Eier", "Rum", "Natursalz", "Hefe"
          ],
          allergens: ["Dinkel", "Milch", "Ei"]
        },
        {
          name: "Vollkorn-Biskuitroulade",
          description: "Lockere Roulade aus Weizenvollkornmehl.",
          image: "/images/products/vollkorn-biskuitroulade.webp",
          ingredients: [
            "Eier", "Weizenvollkornmehl", "Zucker", "Kartoffelstärke",
            "Vanille", "Zitrone", "Marillenmarmelade"
          ],
          allergens: ["Weizen", "Ei"]
        },
        {
          name: "Kaisergugelhupf",
          description: "Hausgemachter Gugelhupf ohne Konservierungsstoffe.",
          image: "/images/products/kaisergugelhupf.webp",
          ingredients: [
            "Weizenmehl", "Margarine", "Zucker", "Eier", "Rum", "Vanille",
            "Zitrone", "Walnüsse", "Schokoladestücke", "Mandelsplitter"
          ],
          allergens: ["Weizen", "Milch", "Ei", "Nüsse"]
        }
      ]
    }
  ]
};

// Brot-Kategorie IDs für spezielle Darstellung
export const breadCategoryIds = ['traditionelle', 'koernige'];

export default sortimentData;
